module.exports = __webpack_public_path__ + "static/media/cw.ec006042.svg";